import { useEffect } from 'react';

function PageTitle({ title }) {
  useEffect(() => {
    // Сохраняем оригинальный title
    const defaultTitle = document.title;
    
    // Устанавливаем новый title
    document.title = `${title} - Metal-ProductionsGroup`;
    
    // Восстанавливаем оригинальный title при размонтировании
    return () => {
      document.title = defaultTitle;
    };
  }, [title]);

  return null;
}

export default PageTitle;